<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-file-account"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row align="center" class="mt-n6 " justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="cv"
              :items-per-page="10"
              class="elevation-1">
            <template v-slot:item.files="{ item }">
              <a :href="download(item.files && item.files.path ?item.files.path : '')"
                 target="_blank">{{ item.files && item.files.name ? item.files.name : '' }}</a>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-eye
              </v-icon>
              <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DELETE_CV, GET_LIST_CV} from "@/store/modules/cv";

export default {
  name: "CV",
  data(){
    return{
      page: "Danh sách CV",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "CV",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {text: 'Full name', value: 'name'},
        {text: 'Phone number', value: 'phone'},
        {text: 'Email address', value: 'email'},
        {text: 'Location', value: 'location'},
        {text: 'File CV', value: 'files'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      url:''
    }
  },
  computed:{
    ...mapGetters({
      cv:"cv",
    })
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_LIST_CV);
  },
  methods:{
    editItem(id) {
      this.$router.push({
        path: "/cv/" + id,
      });
    },
    download(item){
      return `${this.url}/${item}`
    },
    deleteItem(id)
    {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_CV}`,id).then(data=>{
        if(data && data.status === 1) {
          this.$store.dispatch(GET_LIST_CV);
        }
      })
    },
  }

}
</script>

<style scoped>

</style>